import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/sales-commission'
const QUERY_KEY = 'sales-commission'

export const useGetSalesCommissions = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const usePostSalesCommission = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const useDeleteSalesCommission = (config = {}) =>
  useMutation((id) => API.delete(ENDPOINT, { data: id }), config)

export const useExportSalesCommission = (config = {}) =>
  useMutation((body) => API.post(`${ENDPOINT}/export`, body, { responseType: 'blob' }), config)
